import React, { createContext, useContext, useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { sortProductsByNewest } from '../utils/productUtils';

const ProductContext = createContext({ products: [], loading: true });

export const useProducts = () => useContext(ProductContext);

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'products'), (snap) => {
      setProducts(sortProductsByNewest(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
      setLoading(false);
    }, (err) => {
      console.error('상품 구독 실패:', err);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return (
    <ProductContext.Provider value={{ products, loading }}>
      {children}
    </ProductContext.Provider>
  );
};
